import React, { useEffect, useState } from 'react';
import styled, { cutDates, inputNumbers, inputNumbersmall, inputStyle11, inputStyles, inputStyless, stockNumber } from '../../Utils/inputChanges';
import {
    TextField, FormControl, InputLabel, Grid, Paper,
    useMediaQuery, Button, FormHelperText, Table, TableBody, TableCell, TableContainer, Typography,
    TableRow, Autocomplete, TextareaAutosize, Checkbox,
    RadioGroup, FormControlLabel, Radio

} from '@mui/material';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { getCurrentDate } from '../../Utils/Dateutils';
import DateInputComponent from '../FieldsComponents/DateInputComponent';
import { useParams } from 'react-router-dom';
import { fetchPackingData, insertPackingInvoiceEntry } from '../../Store/PHPSlice/Packing/PackApis';
import { selectPackingData } from '../Selectors/PackSelector/PackingSelector';
import RadioComponent from '../FieldsComponents/RadioComponent';
import DateInputComponent2 from '../FieldsComponents/DateInputComponent2';
import axios from 'axios';


const SaleInvoice = () => {
    const userdata = JSON.parse(sessionStorage.getItem('user'));
    const { Id } = useParams();
    const [formData, setFormData] = useState({
        firmId: '',
        firm: '',
        pkId: Id,
        billNo: '',
        billdt: getCurrentDate(),
        pkdt: "",
        pkMemo: '',
        transportId: '',
        transport: "",
        partyId: '',
        party: '',
        adrs: '',
        lrNo: '',
        lrdt: '',
        parcelqty: '',
        shipTo: '',
        ship_adrs: '',
        totqty: '',
        totamt: '',
        freight_ch: '0',
        other_ch: '0',
        grandtot: '',
        gst_type: 'no',
        gst: '5',
        igst: '0',
        cgst: '0',
        sgst: '0',
        state_type: '',
        discnt_type: 'percent',
        discnt_amt: '',
        discnt_val: '18.5',
        netamt: '',
        userId: userdata?.ID
    });
    const singlePack = useSelector(selectPackingData);
    const [packData, setPackData] = useState([]);
    const [billno, setBillno] = useState();
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(fetchPackingData(Id));
        fetchBillInvoiceNo();
    }, [Id]);
    // console.log(formData)
    useEffect(() => {
        if (singlePack?.data) {
            const item = singlePack?.data;
            const discnt_amt = Math.round(parseFloat(item.totamt) / parseFloat(formData.discnt_val));
            let grandtot = parseFloat(item.totamt) - discnt_amt;
            setFormData(prev => ({
                ...prev,
                billNo: billno,
                firm: item.firmNm,
                firmId: item.firmId,
                pkdt: item.dt,
                pkMemo: item.pkMemo,
                transport: item.transportNm,
                transportId: item.transptId,
                party: item.partyNm,
                partyId: item.partyId,
                adrs: item.partyAdrs,
                parcelqty: item.parcel_qty,
                shipTo: item.shipNm,
                ship_adrs: item.ship_adrs,
                totamt: item.totamt,
                totqty: item.totqty,
                discnt_amt: discnt_amt,
                state_type: item.state_type,
                grandtot: grandtot
            }));

        }
        if (singlePack?.Info && singlePack.Info?.length > 0) {
            const info = singlePack.Info;
            setPackData(info);
        }
    }, [singlePack]);
    useEffect(() => {
        if (billno?.data) {
            const values = billno?.data?.billno;
            setFormData(prev => ({
                ...prev,
                billNo: values
            }));
        }
    }, [billno]);
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const fetchBillInvoiceNo = async (id) => {
        try {
            const response = await axios.get(`${baseUrl}?apicall=getBillInvoiceNo`);
            let itemData = response.data;
            // Add new keys with the specified values
            // console.log(itemData)
            setBillno(itemData);
        } catch (error) {
            console.error('Error fetching title list:', error);

        }
    };

    const isDesktop = useMediaQuery('(min-width:768px)');
    const fields = [
        { label: 'Firm', name: 'firm', type: 'readOnly' },
        { label: 'Bill Date', name: 'billdt', type: 'date' },
        { label: 'Bill No', name: 'billNo', type: 'readOnly' },
        { label: 'Packing Slip Date', name: 'pkdt', type: 'readOnly' },
        { label: 'Packing Slip No', name: 'pkMemo', type: 'readOnly' },
        { label: 'Transport Name', name: 'transport', type: 'readOnly' },
        { label: 'Party', name: 'party', type: 'readOnly' },
        { label: 'Address', name: 'adrs', type: 'readOnly' },
        { label: 'Lr No.', name: 'lrNo' },
        { label: 'Lr Date', name: 'lrdt', type: 'date' },
        { label: 'Parcel Qty', name: 'parcelqty', type: 'readOnly' },
        { label: 'Ship To', name: 'shipTo', type: 'readOnly' },
        { label: 'Ship Address', name: 'ship_adrs', type: 'readOnly' },
    ];

    const gstField = [
        { label: 'GST(%)', name: 'gst' },
    ];
    const options_gst = [
        { value: 'yes', label: 'Yes' },
        { value: 'no', label: 'No' },
    ];

    const opts_discnt_amt = [
        { value: 'percent', label: '%' },
        { value: 'rupees', label: 'Rs.' },
    ];

    const fields2 = [
        { label: 'Total Quantity', name: 'totqty', type: 'readOnly' },
        { label: 'Total Amount', name: 'totamt', type: 'readOnly' },
        { label: 'Freight Charges', name: 'freight_ch' },
    ];

    const fields21 = [
        { label: 'Other Charges', name: 'other_ch' },
        { label: 'Gross Total', name: 'grandtot', type: 'readOnly' }
    ];

    const fields4 = [
        { label: 'IGST', name: 'igst', type: 'readOnly' },
        { label: 'CGST', name: 'cgst', type: 'readOnly' },
        { label: 'SGST', name: 'sgst', type: 'readOnly' },
        { label: 'Grand Total', name: 'netamt', type: 'readOnly' }
    ];

    const handleDateChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });

        switch (name) {
            case 'discnt_val':
                if (value) {
                    let totalAmount = parseFloat(formData.totamt);
                    let discnt_amt, grandtot;
                    let other_ch = formData.other_ch !== '' ? parseFloat(formData.other_ch) : 0;
                    let freight_ch = formData.freight_ch !== '' ? parseFloat(formData.freight_ch) : 0;
                    if (formData.discnt_type == 'percent') {

                        discnt_amt = Math.round((parseFloat(value) / 100) * totalAmount);
                        grandtot = totalAmount - discnt_amt + other_ch + freight_ch;
                    } else if (formData.discnt_type == 'rupees') {
                        discnt_amt = parseFloat(value);
                        grandtot = totalAmount - discnt_amt + other_ch + freight_ch;
                    }

                    let igst = 0, cgst = 0, sgst = 0;
                    let cal_grand = Math.round(parseFloat(grandtot) * parseFloat(formData.gst) / 100);
                    if (formData.state_type == '1') {
                        igst = cal_grand;
                    } else {
                        const half_grand = (cal_grand / 2).toFixed(2);
                        cgst = half_grand;
                        sgst = half_grand;
                    }
                    let final_grand_tot = Math.round(parseInt(grandtot, 10) + parseInt(cal_grand, 10));
                    setFormData(prev => ({
                        ...prev,
                        discnt_amt: discnt_amt,
                        grandtot: grandtot,
                        igst: igst || 0,
                        cgst: cgst || 0,
                        sgst: sgst || 0,
                        netamt: final_grand_tot
                    }));
                }
                break;
        }
    };

    const handleRadioChange = (event) => {
        setFormData({
            ...formData,
            [event.target.name]: event.target.value,
        });

        if (event.target.value === 'yes') {
            const update_gross = parseInt(formData.totamt, 10) - parseInt(formData.discnt_amt, 10) + parseInt(formData.freight_ch, 10) + parseInt(formData.other_ch, 10);

            let igst = 0, cgst = 0, sgst = 0;
            let cal_grand = Math.round(parseFloat(update_gross) * parseFloat(formData.gst) / 100);
            if (formData.state_type == '1') {
                igst = cal_grand;
            } else {
                const half_grand = (cal_grand / 2).toFixed(2);
                cgst = half_grand;
                sgst = half_grand;
            }
            let final_grand_tot = Math.round(parseInt(update_gross, 10) + parseInt(cal_grand, 10));

            setFormData(prevFormData => ({
                ...prevFormData,
                grandtot: update_gross,
                igst: igst || 0,
                cgst: cgst || 0,
                sgst: sgst || 0,
                netamt: final_grand_tot
            }));

        }
        if (event.target.value === 'no') {
            const gross_tot = parseInt(formData.totamt, 10) - parseInt(formData.discnt_amt, 10);
            const update_gross = parseInt(gross_tot, 10) + parseInt(formData.freight_ch, 10) + parseInt(formData.other_ch, 10);
            let igst = 0, cgst = 0, sgst = 0;
            let cal_grand = Math.round(parseFloat(update_gross) * parseFloat(formData.gst) / 100);
            if (formData.state_type == '1') {
                igst = 0;
            } else {
                cgst = 0;
                sgst = 0;
            }
            let final_grand_tot = 0;

            setFormData(prevFormData => ({
                ...prevFormData,
                grandtot: update_gross,
                igst: igst || 0,
                cgst: cgst || 0,
                sgst: sgst || 0,
                netamt: final_grand_tot
            }));
        }
    };

    const handleInputComplete = (e) => {
        const { name, value } = e.target;

        switch (name) {
            case 'gst':
                if (value) {
                    const total_amt = parseInt(formData.totamt, 10);
                    const gst_amt = Math.round(total_amt * parseFloat(formData.discnt_val) / 100);
                    const grandtot2 = Math.round(total_amt - gst_amt + parseFloat(formData.other_ch) + parseFloat(formData.freight_ch));

                    let igst = 0, cgst = 0, sgst = 0, netamt = 0;
                    if (formData.state_type == '1') {
                        igst = Math.round(grandtot2 * parseFloat(value) / 100);
                        netamt = igst + grandtot2;
                    } else if (formData.state_type == '0') {
                        const diff = Math.round(grandtot2 * parseFloat(value) / 100);
                        cgst = Math.round(diff / 2);
                        sgst = Math.round(diff / 2);
                        netamt = diff + grandtot2;
                    }

                    setFormData(prev => ({
                        ...prev,
                        igst: igst || 0,
                        cgst: cgst || 0,
                        sgst: sgst || 0,
                        netamt: netamt
                    }));
                }
                break;

            case 'freight_ch':
                if (value) {
                    const total_amt = parseInt(formData.totamt, 10);
                    const gst_amt = Math.round(total_amt * parseFloat(formData.discnt_val) / 100);
                    const grandtot2 = Math.round(total_amt - gst_amt);
                    const other_ch = formData.other_ch !== '' ? parseFloat(formData.other_ch) : 0;
                    let final_grand = grandtot2 + parseFloat(value) + other_ch;
                    setFormData(prev => ({
                        ...prev,
                        grandtot: final_grand
                    }));
                    if (formData.gst_type === 'yes') {
                        let gst_cal, igst, cgst, sgst;

                        gst_cal = Math.round(final_grand * parseFloat(formData.gst) / 100);

                        if (formData.state_type == '1') {
                            igst = gst_cal;
                        } else if (formData.state_type == '0') {
                            cgst = Math.round(gst_cal / 2);
                            sgst = Math.round(gst_cal / 2);
                        }

                        let netamt = final_grand + gst_cal;
                        setFormData(prev => ({
                            ...prev,
                            grandtot: final_grand,
                            igst: igst || 0,
                            cgst: cgst || 0,
                            sgst: sgst || 0,
                            netamt: netamt
                        }));

                    }
                }
                break;
            case 'other_ch':
                if (value) {

                    const total_amt = parseInt(formData.totamt, 10);
                    const gst_amt = Math.round(total_amt * parseFloat(formData.discnt_val) / 100);
                    const grandtot2 = Math.round(total_amt - gst_amt);
                    const freight_ch = formData.freight_ch !== "" ? parseFloat(formData.freight_ch) : 0;
                    const final_grand = grandtot2 + parseFloat(value) + freight_ch;

                    if (formData.gst_type === 'yes') {
                        let gst_cal = parseFloat((final_grand * parseFloat(formData.gst) / 100).toFixed(2));
                        let igst = 0, cgst = 0, sgst = 0;

                        if (formData.state_type === '1') {
                            igst = gst_cal;
                        } else if (formData.state_type === '0') {
                            cgst = parseFloat((gst_cal / 2).toFixed(2));
                            sgst = parseFloat((gst_cal / 2).toFixed(2));
                        }

                        let netamt = Math.round((final_grand + gst_cal))
                        setFormData(prev => ({
                            ...prev,
                            grandtot: final_grand,
                            igst: igst,
                            cgst: cgst,
                            sgst: sgst,
                            netamt: netamt
                        }));
                    } else {
                        setFormData(prev => ({
                            ...prev,
                            grandtot: final_grand
                        }));
                    }

                }
                break;

        }
    }
    const tableContainerStyle = {
        marginTop: '1%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',
        overflowY: 'hidden',
        WebkitOverflowScrolling: 'touch',
    };

    function postObj(formData, packData) {
        const totamt = formData.netamt !== '' ? formData.netamt : formData.grandtot;
        const discnt_type = formData.discnt_type === 'percent' ? '%' : 'Rs';
        // const discnt_type = formData.discnt_type;
        const gst_type = formData.gst_type === 'yes' ? '1' : '0';

        const data = {
            dt: formData.billdt,
            pkId: formData.pkId,
            billNo: formData.billNo,
            firmId: formData.firmId,
            partyId: formData.partyId,
            total_amt: formData.totamt,
            discnt_type: discnt_type,
            discnt_val: formData.discnt_val,
            discnt_amt: formData.discnt_amt,
            freight_ch: formData.freight_ch,
            other_ch: formData.other_ch,
            transport: formData.transport,
            lrno: formData.lrNo,
            lrdt: formData.lrdt,
            party_state: formData.state_type,
            firm_tax_sts: gst_type,
            gst_val: formData.gst,
            igst: formData.igst,
            cgst: formData.cgst,
            sgst: formData.sgst,
            net_amt: totamt,
            shipto: formData.shipTo,
            ship_adrs: formData.ship_adrs,
            parcelqty: formData.parcelqty,
            totqty: formData.totqty,
            userId: formData.userId,
            pkInfo: packData,
            pkdata: formData.pkId
        };
        return data;
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const finalObject = postObj(formData, packData);
        console.log(finalObject)

        if (!formData.lrNo || formData.lrNo.trim() === '') {
            alert("LR No. is required.");
            return; // Stop the submission if validation fails
        }

        if (!formData.lrdt || formData.lrdt.trim() === '') {
            alert("LR Date is required.");
            return; // Stop the submission if validation fails
        }

        dispatch(insertPackingInvoiceEntry(finalObject))
            .unwrap()
            .then((result) => {
                // Handle success
                console.log('POST request successful!', result);
                alert("Records Inserted");
                window.close();
            })
            .catch((error) => {
                // Handle error
                console.error('Error while making POST request:', error);
                // You may want to display an error message to the user or perform any other action
            });
    };

    console.log(packData);
    return (
        <>
            <div style={{ margin: '1% 0.5%' }}>
                <h2 style={{ textAlign: 'center' }}>Generate Bill / Estimate</h2>

                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={0.5}>

                                {fields.map((field) => (
                                    <DateInputComponent2
                                        key={field.name}
                                        formData={formData}
                                        handleDateChange={handleDateChange}
                                        handleInputChange={handleInputChange}
                                        styled={styled}
                                        inputStyles={inputStyles}
                                        isDesktop={isDesktop}
                                        field={field}
                                        handleInputComplete={handleInputComplete}
                                    />
                                ))}

                                {Array.isArray(packData) && packData.length > 0 &&
                                    <>
                                        <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                                            <Table style={isDesktop ? { width: '100%' } : { width: '100%' }}>
                                                <TableBody>

                                                    <TableRow>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>SR.NO.</TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>PARTICULARS</TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>SIZE</TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>RATE</TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>QTY</TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>AMOUNT</TableCell>
                                                    </TableRow>
                                                    {
                                                        packData.map((item, index) => (
                                                            <TableRow key={index}>

                                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' >{index + 1}</TableCell>
                                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' >{item.Particulars}</TableCell>
                                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' >{item.size}</TableCell>
                                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{item.rate}</TableCell>
                                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{item.actqty}</TableCell>
                                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{item.tot}</TableCell>
                                                            </TableRow>
                                                        ))
                                                    }
                                                </TableBody>
                                            </Table>
                                        </TableContainer>

                                    </>
                                }

                                <RadioComponent
                                    label='GST'
                                    name='gst_type'
                                    value={formData.gst_type}
                                    options={options_gst}
                                    onChange={handleRadioChange}
                                    isDesktop={true}
                                />

                                {formData.gst_type === 'yes' ?

                                    <>
                                        {gstField.map((field) => (
                                            <DateInputComponent2
                                                key={field.name}
                                                formData={formData}
                                                handleDateChange={handleDateChange}
                                                handleInputChange={handleInputChange}
                                                styled={styled}
                                                inputStyles={inputStyles}
                                                isDesktop={isDesktop}
                                                field={field}
                                                handleInputComplete={handleInputComplete}
                                            />
                                        ))}
                                    </>
                                    : (
                                        <Grid item xs={12} md={6}>
                                        </Grid>
                                    )
                                }

                                {fields2.map((field) => (
                                    <DateInputComponent2
                                        key={field.name}
                                        formData={formData}
                                        handleDateChange={handleDateChange}
                                        handleInputChange={handleInputChange}
                                        styled={styled}
                                        inputStyles={inputStyles}
                                        isDesktop={isDesktop}
                                        field={field}
                                        handleInputComplete={handleInputComplete}
                                    />
                                ))}

                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel htmlFor="discnt_amt">Discount Amount:</InputLabel>
                                            <RadioGroup row name="discnt_type" value={formData.discnt_type} onChange={handleRadioChange}>
                                                {opts_discnt_amt.map((option) => (
                                                    <FormControlLabel
                                                        key={option.value}
                                                        value={option.value}
                                                        control={<Radio />}
                                                        label={option.label}
                                                    />
                                                ))}
                                                {/* <input type="text" name='discnt_val' value={formData.discnt_val} onChange={handleInputChange}
                                                    style={{ width: '50px', height: '25px', paddingLeft: '5px', marginTop: '1px', color: 'red', fontSize: '15px' }} /> */}
                                            </RadioGroup>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth style={{ display: 'flex', flexDirection: 'row', gap: '10px' }}>
                                                <TextField
                                                    id="discnt_val"
                                                    name="discnt_val"
                                                    value={formData.discnt_val}
                                                    onChange={handleInputChange}
                                                    inputProps={{ style: styled.inputs }}
                                                    sx={inputNumbersmall}
                                                />
                                                <TextField
                                                    id="discnt_amt"
                                                    name="discnt_amt"
                                                    value={formData.discnt_amt}
                                                    onChange={handleInputChange}
                                                    inputProps={{ style: styled.input, readOnly: true }}
                                                    sx={inputStyle11}
                                                />
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                {fields21.map((field) => (
                                    <DateInputComponent2
                                        key={field.name}
                                        formData={formData}
                                        handleDateChange={handleDateChange}
                                        handleInputChange={handleInputChange}
                                        styled={styled}
                                        inputStyles={inputStyles}
                                        isDesktop={isDesktop}
                                        field={field}
                                        handleInputComplete={handleInputComplete}
                                    />
                                ))}

                                {formData.gst_type === 'yes' &&
                                    <>
                                        {
                                            fields4.map((field) => (
                                                <DateInputComponent
                                                    key={field.name}
                                                    formData={formData}
                                                    handleDateChange={handleDateChange}
                                                    handleInputChange={handleInputChange}
                                                    styled={styled}
                                                    inputStyles={inputStyles}
                                                    isDesktop={isDesktop}
                                                    field={field}
                                                />
                                            ))
                                        }
                                    </>

                                }

                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit}>Submit</Button>
                                </Grid>

                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        </>
    );
}

export default SaleInvoice;
